/* eslint-disable @typescript-eslint/member-ordering */
import { Component, computed, effect, inject, OnInit, untracked } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { faCodeBranch, faEllipsisVertical, faSquarePollHorizontal, faTrashCan } from '@fortawesome/pro-regular-svg-icons';

import { ConfirmDialogComponent } from '@eiq/ui';

import { BlockType } from '@empathy/survey/base';

import { BlockTypeIconConfig } from '../../../models/blocks/block-type-config.constants';
import { SideBlocksTabs } from '../../../models/side-blocks-tabs.enum';
import { BlockTypeContainers } from '../../../models/survey-editor/block-type.constants';
import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-block-form',
  templateUrl: 'block-form.component.html',
  styleUrls: ['./block-form.component.scss']
})
export class BlockFormComponent implements OnInit {
  blockType = BlockType;
  blockTypeConfig = BlockTypeIconConfig;
  sideTabs = SideBlocksTabs;

  faCodeBranch = faCodeBranch;
  faEllipsisVertical = faEllipsisVertical;
  faSquarePollHorizontal = faSquarePollHorizontal;
  faTrashCan = faTrashCan;

  private readonly surveyEditorService = inject(SurveyEditorService);

  activeBlock$ = this.surveyEditorService.surveyEditor$().blocks.active$;
  activeAllowsConditionals$ = this.surveyEditorService.surveyEditor$().blocks.activeAllowsConditionals$;
  activeTab$ = this.surveyEditorService.activeTab$;

  readonly hasBlockActions$ = computed(() => this.activeAllowsConditionals$() || this.activeBlock$().value.type === BlockType.MultiBlock);

  private dialog = inject(MatDialog);

  constructor() {
    effect(
      () => {
        if (this.activeBlock$()) {
          // Closing reads the side tab; tab changes must not retrigger this block-selection effect.
          untracked(() => this.surveyEditorService.closeLoopSettings());
        }
      },
      { allowSignalWrites: true }
    );
  }

  ngOnInit(): void {
    this.surveyEditorService.activeTab$.set(SideBlocksTabs.Conditions);
  }

  onOpenSideTab(sideTab: SideBlocksTabs): void {
    this.surveyEditorService.activeTab$.set(sideTab);
  }

  onRemove(): void {
    const confirmMessage = BlockTypeContainers.includes(this.activeBlock$().value.type)
      ? 'Are you sure you want to remove this block? This action will remove the sub-groups configured'
      : 'Are you sure you want to remove this block?';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { title: 'Confirm', confirmText: confirmMessage, confirmBtn: 'Remove', color: 'warn' }
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.surveyEditorService.surveyEditor$().blocks.removeActive();
      }
    });
  }
}
